<!-- Modal -->
<div class="modal-header">
  <h5 class="modal-title" id="exampleModalCenterTitle">
    {{ 'BENEFIT_CONFIRM_MODAL.TITLE' | translate }}
  </h5>
  <button type="button" class="close" (click)="activeModal.dismiss('Cross click')" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" tabindex="0" ngbAutofocus>
  <div class="custom-control custom-checkbox mt-1">
    <input
      type="checkbox"
      class="custom-control-input"
      id="insurance-terms-checkbox"
      [(ngModel)]="termsAccepted"
      [disabled]="isLoading"
    />
    <label class="custom-control-label" for="insurance-terms-checkbox">
      {{ 'BENEFIT_CONFIRM_MODAL.CHECKBOX_LABEL' | translate }}
      <br/>
      <b>{{ 'BENEFIT_CONFIRM_MODAL.CHECKBOX_LABEL_2' | translate }}</b>
    </label>
  </div>

  <p>
    {{ 'BENEFIT_CONFIRM_MODAL.DISCLAIMER_PART1' | translate }}
    <a [href]="privacyPolicyUrl" target="_blank">{{ 'BENEFIT_CONFIRM_MODAL.POLICY_LINK' | translate }}</a>.
  </p>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!termsAccepted || isLoading"
    (click)="confirm()"
    rippleEffect
  >
    <span
      *ngIf="isLoading"
      class="spinner-border spinner-border-sm mr-1"
      role="status"
      aria-hidden="true"
    ></span>
    {{ 'BENEFIT_CONFIRM_MODAL.BUTTON' | translate }}
  </button>
</div>
<!-- / Modal -->
